import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=2ed216ec&lang=scss&scoped=true"

import exportComponent from "C:\\AQ_Repo\\customermanagedinspection_fe - Brandsäkra Norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed216ec"]])

export default __exports__